import { render } from "./SortedTable.vue?vue&type=template&id=b10280e6"
import script from "./SortedTable.vue?vue&type=script&lang=js"
export * from "./SortedTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__